import React, { Component } from 'react';
import { Typography, Tooltip } from 'antd';

const { Text } = Typography;

class SignView extends Component {
    state = {
        text: this.props.text,
        color: this.props.color,
        background: this.props.background,
        width: this.props.width,
        textAlign: this.props.textAlign,
        tooltip: this.props.tooltip
    }

    render() {
        const textStyle = {
            backgroundColor: this.state.background,
            color: this.state.color,
            display: 'inline-block',
            padding: '3px 3px',
            lineHeight: '30px',
            fontWeight: 'bold',
            fontSize: '15px',
            textAlign: this.state.textAlign,
            width: this.state.width
        };
        return (
            <Text title={this.state.tooltip} style={textStyle}>{this.state.text}</Text>
        );
    }
}
export default SignView;


// WEBPACK FOOTER //
// ./src/components/SignView.js